// Light + dark variants swapped via the `dark:` Tailwind variant. Native asset
// aspect ratio is 2400:645 ≈ 3.72:1, same as the frontend Logo component.
export function Logo({ width, className = '' }: { width: number; className?: string }) {
  const height = Math.round(width / (2400 / 645));
  return (
    <>
      <img
        src="/logo/godrop-pri-L.webp"
        alt="GoDrop"
        width={width}
        height={height}
        className={`block dark:hidden ${className}`}
      />
      <img
        src="/logo/godrop-pri-D.webp"
        alt=""
        aria-hidden
        width={width}
        height={height}
        className={`hidden dark:block ${className}`}
      />
    </>
  );
}
